export enum CtaLayout {
  LAYOUT1 = 'cta_layout1',
  LAYOUT2 = 'cta_layout2',
}
